import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-switch_open",
  "use": "icon-switch_open-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-switch_open\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n\t<path d=\"M4,12a5,5,0,0,0,5.09,5h5.82a5,5,0,1,0,0-10H9.09A5,5,0,0,0,4,12Zm8.5,0A2.5,2.5,0,1,1,15,14.5,2.5,2.5,0,0,1,12.5,12Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol